import { useMutation, MutationConfigType, UseMutationResult } from "~/libs";

import { ApiClient } from "~/utils";

import {
  ApiManagersSkillEvaluationStandardSummaryMutateType,
  RawDraftContentState,
} from "~/domains";

type RequestDataType = {
  id: string;
  skillEvaluationStandardSummaryCategoryId: string;
  body: {
    title: string;
    content: RawDraftContentState;
    displayOrder: number;
    skillEvaluationStandards: {
      title: string;
      description: string;
      point: number;
    }[];
  };
};

const request = ({
  id,
  skillEvaluationStandardSummaryCategoryId,
  body,
}: RequestDataType) => {
  return new ApiClient()
    .put<ApiManagersSkillEvaluationStandardSummaryMutateType>(
      `/api/managers/skill_evaluation_standard_summary_categories/${skillEvaluationStandardSummaryCategoryId}/skill_evaluation_standard_summaries/${id}`,
      { skillEvaluationStandardSummary: body },
    )
    .then((res) => {
      return res.data;
    });
};

type PropsType = {
  options?: MutationConfigType<typeof request>;
};

export const useApisManagerSkillEvaluationStandardSummaryCategoriesSkillEvaluationStandardSummariesUpdate =
  ({ options = {} }: PropsType = {}): UseMutationResult<
    ApiManagersSkillEvaluationStandardSummaryMutateType,
    RequestDataType
  > => {
    return useMutation(request, { ...options });
  };
